/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getValidBadges.defs.js";
export { main as default } from "./getValidBadges.defs.js";
